import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../utils/api';
import { LogoFull } from './Logo';

function Register({ onLogin }) {
  var navigate = useNavigate();
  var [form, setForm] = useState({ userId: '', password: '', passwordConfirm: '', companyName: '', companyNameEn: '', ceo: '', tel: '', bizNo: '', email: '', companyType: 'user' });
  var [agreeTerms, setAgreeTerms] = useState(false);
  var [agreePrivacy, setAgreePrivacy] = useState(false);
  var [honeypot, setHoneypot] = useState('');
  var [error, setError] = useState('');
  var [success, setSuccess] = useState('');
  var [loading, setLoading] = useState(false);
  var [idCheck, setIdCheck] = useState(null);
  var [showPw, setShowPw] = useState(false);
  var [bizFile, setBizFile] = useState(null);
  var [bizPreview, setBizPreview] = useState(null);
  var [ocrLoading, setOcrLoading] = useState(false);
  var [submitted, setSubmitted] = useState(false);

  var set = function(k, v) { var f = Object.assign({}, form); f[k] = v; setForm(f); if (k === 'userId') setIdCheck(null); };

  var getPasswordStrength = function(pw) {
    if (!pw) return { level: 0, label: '', color: '#e5e7eb' };
    var score = 0;
    if (pw.length >= 8) score++;
    if (/[a-zA-Z]/.test(pw)) score++;
    if (/[0-9]/.test(pw)) score++;
    if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pw)) score++;
    if (pw.length >= 12) score++;
    if (score <= 2) return { level: 1, label: '약함', color: '#ef4444' };
    if (score <= 3) return { level: 2, label: '보통', color: '#f59e0b' };
    return { level: 3, label: '강함', color: '#16a34a' };
  };
  var pwStrength = getPasswordStrength(form.password);
  // 서버 validatePassword(routes/auth.js:21)와 동일 조건 — 실시간 체크리스트 + submit 검증 단일 소스
  var pwConditions = {
    length: (form.password || '').length >= 8,
    letter: /[a-zA-Z]/.test(form.password || ''),
    number: /[0-9]/.test(form.password || ''),
    special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(form.password || '')
  };
  var pwAllMet = pwConditions.length && pwConditions.letter && pwConditions.number && pwConditions.special;

  var handleBizFile = function(file) {
    if (!file) return;
    setBizFile(file);
    if (file.type.startsWith('image/')) {
      var reader = new FileReader();
      reader.onload = function(e) { setBizPreview(e.target.result); };
      reader.readAsDataURL(file);
    } else { setBizPreview(null); }
    // OCR 시도
    setOcrLoading(true);
    var fd = new FormData(); fd.append('image', file);
    fetch(API + '/auth/register-ocr', { method: 'POST', body: fd })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        setOcrLoading(false);
        if (d.success && d.data) {
          var r = d.data;
          setForm(function(prev) { return Object.assign({}, prev, {
            companyName: r.name || prev.companyName,
            ceo: r.ceo || prev.ceo,
            bizNo: r.bizNo || prev.bizNo,
            tel: r.tel || prev.tel,
          }); });
        }
      }).catch(function() { setOcrLoading(false); });
  };

  var checkId = function() {
    if (!form.userId || form.userId.length < 3) { setIdCheck(false); return; }
    fetch(API + '/auth/check-id?userId=' + encodeURIComponent(form.userId))
      .then(function(r) { return r.json(); })
      .then(function(d) { setIdCheck(d.available); })
      .catch(function() { setIdCheck(null); });
  };

  var handleSubmit = function() {
    setError(''); setSuccess('');
    if (!form.userId || form.userId.length < 3) { setError('아이디는 3자 이상 입력해주세요.'); return; }
    if (!form.password || form.password.length < 8) { setError('비밀번호는 8자 이상 입력해주세요.'); return; }
    if (!/[a-zA-Z]/.test(form.password)) { setError('비밀번호에 영문자를 포함해주세요.'); return; }
    if (!/[0-9]/.test(form.password)) { setError('비밀번호에 숫자를 포함해주세요.'); return; }
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(form.password)) { setError('비밀번호에 특수문자를 포함해주세요.'); return; }
    if (form.password !== form.passwordConfirm) { setError('비밀번호가 일치하지 않습니다.'); return; }
    if (!form.companyName) { setError('업체명을 입력해주세요.'); return; }
    if (!agreeTerms || !agreePrivacy) { setError('이용약관 및 개인정보처리방침에 모두 동의해주세요.'); return; }
    if (honeypot) return; // bot trap
    setLoading(true);
    var fd = new FormData();
    fd.append('userId', form.userId.trim());
    fd.append('password', form.password);
    fd.append('companyName', form.companyName);
    fd.append('companyNameEn', form.companyNameEn);
    fd.append('ceo', form.ceo);
    fd.append('tel', form.tel);
    fd.append('bizNo', form.bizNo);
    fd.append('email', form.email);
    fd.append('companyType', form.companyType);
    if (bizFile) fd.append('bizLicense', bizFile);
    fetch(API + '/auth/register', { method: 'POST', body: fd })
    .then(function(r) { return r.json(); }).then(function(d) {
      if (d.success && d.pending) {
        // 승인 대기 모달 노출 + 폼 영구 잠금 (재클릭으로 인한 rate limit 방지)
        setSubmitted(true);
        setLoading(false);
      } else if (d.success) {
        if (d.token) localStorage.setItem('autodoc_token', d.token);
        setSuccess('가입 완료!');
        setTimeout(function() { onLogin(d.user); navigate('/main'); }, 1200);
      } else { setError(d.error || '가입 실패'); setLoading(false); }
    }).catch(function() { setError('서버 연결 실패'); setLoading(false); });
  };

  var is = { width: '100%', height: 44, paddingLeft: 14, paddingRight: 14, border: '1.5px solid #e2e8f0', borderRadius: 10, fontSize: 14, outline: 'none', backgroundColor: '#f8fafc', fontFamily: "'Pretendard',sans-serif", boxSizing: 'border-box' };
  var lb = { display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 };
  var rw = { marginBottom: 14 };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(180deg,#f8fafc 0%,#eff6ff 100%)', fontFamily: "'Pretendard',sans-serif", padding: 20, position: 'relative', overflow: 'hidden' }}>
      {submitted && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: 'white', borderRadius: 20, padding: '36px 32px', maxWidth: 420, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)', textAlign: 'center' }}>
            <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 40, margin: '0 auto 18px' }}>✅</div>
            <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', marginBottom: 10 }}>가입 신청 완료</h2>
            <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 22 }}>
              관리자 <strong style={{ color: '#2563eb' }}>승인 대기 중</strong>입니다.<br />
              승인이 완료되면 {form.email ? <><strong>{form.email}</strong>로 </> : ''}안내드리며,<br />
              그 후 로그인하여 서비스를 이용하실 수 있습니다.
            </p>
            <div style={{ background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: 10, padding: '10px 14px', marginBottom: 20, fontSize: 12, color: '#92400e', lineHeight: 1.6 }}>
              ⚠️ 여러 번 제출하지 마세요. 추가 요청은 자동 차단될 수 있습니다.
            </div>
            <button onClick={function() { navigate('/login'); }} style={{ width: '100%', height: 48, backgroundColor: '#2563eb', color: 'white', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: "'Pretendard',sans-serif", boxShadow: '0 4px 12px rgba(37,99,235,0.3)' }}>
              로그인 페이지로 →
            </button>
          </div>
        </div>
      )}
      <div style={{ position: 'absolute', top: -200, right: -200, width: 600, height: 600, background: '#dbeafe', borderRadius: '50%', filter: 'blur(100px)', opacity: 0.4, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -200, left: -200, width: 500, height: 500, background: '#e0f2fe', borderRadius: '50%', filter: 'blur(100px)', opacity: 0.4, pointerEvents: 'none' }} />
      <div style={{ width: '100%', maxWidth: 460, position: 'relative', zIndex: 10 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <LogoFull iconSize={36} fontSize={24} />
          <p style={{ color: '#94a3b8', fontSize: 13, fontWeight: 500 }}>90일 무료 체험 시작</p>
        </div>
        <div style={{ backgroundColor: 'white', borderRadius: 20, padding: '32px 32px', boxShadow: '0 4px 40px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0' }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>회원가입</h2>
          <p style={{ fontSize: 13, color: '#94a3b8', marginBottom: 24 }}>가입 후 관리자 승인이 완료되면 90일 체험판이 시작됩니다</p>

          {error && <div style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '10px 14px', marginBottom: 16, color: '#dc2626', fontSize: 13, fontWeight: 500 }}>{error}</div>}
          {success && <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '10px 14px', marginBottom: 16, color: '#16a34a', fontSize: 13, fontWeight: 500 }}>{success}</div>}

          <div style={rw}>
            <label style={lb}>아이디 *</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input value={form.userId} onChange={function(e) { set('userId', e.target.value.replace(/[^a-zA-Z0-9_]/g, '')); }} placeholder="영문/숫자 3자 이상" style={{ ...is, flex: 1 }} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
              <button onClick={checkId} style={{ padding: '0 14px', border: '1.5px solid #e2e8f0', borderRadius: 10, fontSize: 12, fontWeight: 600, cursor: 'pointer', background: '#f8fafc', color: '#475569', whiteSpace: 'nowrap' }}>중복확인</button>
            </div>
            {idCheck === true && <div style={{ fontSize: 11, color: '#16a34a', marginTop: 4 }}>사용 가능한 아이디입니다.</div>}
            {idCheck === false && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>사용할 수 없는 아이디입니다.</div>}
          </div>

          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ ...rw, flex: 1 }}>
              <label style={lb}>비밀번호 *</label>
              <div style={{ position: 'relative' }}>
                <input type={showPw ? 'text' : 'password'} value={form.password} onChange={function(e) { set('password', e.target.value); }} placeholder="8자 이상 (영문+숫자+특수)" style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
                <button onClick={function() { setShowPw(!showPw); }} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: '#94a3b8', padding: 2 }}>{showPw ? '🙈' : '👁'}</button>
              </div>
              {form.password && <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
                <div style={{ flex: 1, height: 4, background: '#e5e7eb', borderRadius: 2, overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: (pwStrength.level / 3 * 100) + '%', background: pwStrength.color, borderRadius: 2, transition: 'all 0.2s' }} />
                </div>
                <span style={{ fontSize: 10, color: pwStrength.color, fontWeight: 600, minWidth: 28 }}>{pwStrength.label}</span>
              </div>}
            </div>
            <div style={{ ...rw, flex: 1 }}>
              <label style={lb}>비밀번호 확인 *</label>
              <input type="password" value={form.passwordConfirm} onChange={function(e) { set('passwordConfirm', e.target.value); }} placeholder="비밀번호 재입력" style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
              {form.passwordConfirm && form.password !== form.passwordConfirm && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>비밀번호 불일치</div>}
            </div>
          </div>

          {/* 비밀번호 조건 실시간 체크리스트 — 서버 validatePassword와 동일 조건 */}
          <div style={{ background: pwAllMet ? '#f0fdf4' : '#f8fafc', border: '1px solid ' + (pwAllMet ? '#bbf7d0' : '#e2e8f0'), borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 12, transition: 'all 0.2s' }}>
            <div style={{ fontWeight: 600, color: '#475569', marginBottom: 6, fontSize: 11 }}>비밀번호 조건</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px' }}>
              {[
                { key: 'length', label: '8자 이상' },
                { key: 'letter', label: '영문 포함' },
                { key: 'number', label: '숫자 포함' },
                { key: 'special', label: '특수문자 포함' }
              ].map(function(c) {
                var ok = pwConditions[c.key];
                return (
                  <div key={c.key} style={{ display: 'flex', alignItems: 'center', gap: 6, color: ok ? '#16a34a' : '#94a3b8', fontWeight: ok ? 600 : 400 }}>
                    <span style={{ width: 16, height: 16, borderRadius: '50%', background: ok ? '#16a34a' : '#e2e8f0', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, flexShrink: 0 }}>{ok ? '✓' : '·'}</span>
                    <span>{c.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <hr style={{ border: 'none', borderTop: '1px solid #f1f5f9', margin: '8px 0 16px' }} />

          <div style={rw}>
            <label style={lb}>업체 유형 *</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {[
                { value: 'user', label: '수출업체 (일반)' },
                { value: 'doc_agency', label: '서류대행업체' },
                { value: 'cancel_agency', label: '말소대행업체' },
              ].map(function(t) {
                var sel = form.companyType === t.value;
                return (
                  <label key={t.value} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 10, cursor: 'pointer', border: sel ? '1.5px solid #2563eb' : '1.5px solid #e2e8f0', background: sel ? '#eff6ff' : '#f8fafc', transition: 'all 0.15s' }}>
                    <span style={{ width: 18, height: 18, borderRadius: '50%', border: sel ? '5px solid #2563eb' : '2px solid #cbd5e1', boxSizing: 'border-box', flexShrink: 0, transition: 'all 0.15s' }} />
                    <input type="radio" name="companyType" value={t.value} checked={sel} onChange={function() { set('companyType', t.value); }} style={{ display: 'none' }} />
                    <span style={{ fontSize: 13, fontWeight: sel ? 600 : 500, color: sel ? '#1e40af' : '#475569' }}>{t.label}</span>
                  </label>
                );
              })}
            </div>
          </div>

          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ ...rw, flex: 1 }}>
              <label style={lb}>업체명 (한글) *</label>
              <input value={form.companyName} onChange={function(e) { set('companyName', e.target.value); }} placeholder="(주)무역상사" style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
            </div>
            <div style={{ ...rw, flex: 1 }}>
              <label style={lb}>업체명 (영문)</label>
              <input value={form.companyNameEn} onChange={function(e) { set('companyNameEn', e.target.value); }} placeholder="Trading Co." style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ ...rw, flex: 1 }}>
              <label style={lb}>대표자명</label>
              <input value={form.ceo} onChange={function(e) { set('ceo', e.target.value); }} placeholder="홍길동" style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
            </div>
            <div style={{ ...rw, flex: 1 }}>
              <label style={lb}>전화번호</label>
              <input value={form.tel} onChange={function(e) { set('tel', e.target.value); }} placeholder="010-1234-5678" type="tel" style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
            </div>
          </div>

          <div style={rw}>
            <label style={lb}>사업자등록번호 <span style={{ color: '#94a3b8', fontWeight: 400 }}>(선택)</span></label>
            <input value={form.bizNo} onChange={function(e) { set('bizNo', e.target.value); }} placeholder="000-00-00000" style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
          </div>

          <div style={rw}>
            <label style={lb}>이메일 <span style={{ color: '#94a3b8', fontWeight: 400 }}>(승인 알림 수신용)</span></label>
            <input type="email" value={form.email} onChange={function(e) { set('email', e.target.value); }} placeholder="example@company.com" style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
          </div>

          {/* honeypot — hidden from humans */}
          <div style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, overflow: 'hidden' }} aria-hidden="true">
            <input value={honeypot} onChange={function(e) { setHoneypot(e.target.value); }} tabIndex={-1} autoComplete="off" />
          </div>

          <div style={rw}>
            <label style={lb}>사업자등록증 <span style={{ color: '#94a3b8', fontWeight: 400 }}>(선택 — 업로드 시 자동입력)</span></label>
            <div style={{ border: '1.5px dashed #cbd5e1', borderRadius: 10, padding: 14, textAlign: 'center', cursor: 'pointer', background: bizFile ? '#f0fdf4' : '#f8fafc', transition: 'all 0.15s' }}
              onClick={function() { document.getElementById('bizLicenseInput').click(); }}
              onDragOver={function(e) { e.preventDefault(); e.currentTarget.style.borderColor = '#3b82f6'; }}
              onDragLeave={function(e) { e.currentTarget.style.borderColor = '#cbd5e1'; }}
              onDrop={function(e) { e.preventDefault(); e.currentTarget.style.borderColor = '#cbd5e1'; if (e.dataTransfer.files[0]) handleBizFile(e.dataTransfer.files[0]); }}>
              {ocrLoading ? <div style={{ fontSize: 13, color: '#3b82f6', fontWeight: 600 }}>AI 분석 중...</div>
                : bizFile ? <div style={{ fontSize: 12, color: '#16a34a', fontWeight: 600 }}>{bizFile.name} ({(bizFile.size / 1024).toFixed(0)}KB)</div>
                : <div><div style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>클릭 또는 드래그하여 업로드</div><div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>JPG, PNG, PDF (최대 10MB)</div></div>}
              <input id="bizLicenseInput" type="file" accept="image/jpeg,image/png,application/pdf" style={{ display: 'none' }} onChange={function(e) { if (e.target.files[0]) handleBizFile(e.target.files[0]); e.target.value = ''; }} />
            </div>
            {bizPreview && <img src={bizPreview} alt="미리보기" style={{ marginTop: 8, maxHeight: 120, borderRadius: 8, border: '1px solid #e2e8f0' }} />}
          </div>

          <div style={{ ...rw, marginBottom: 6 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <input type="checkbox" checked={agreeTerms} onChange={function(e) { setAgreeTerms(e.target.checked); }} id="ck-terms" style={{ flexShrink: 0 }} />
              <label htmlFor="ck-terms" style={{ fontSize: 12, color: '#475569', cursor: 'pointer' }}>
                <a href="/terms" target="_blank" style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 600 }}>이용약관</a>에 동의합니다 <span style={{ color: '#dc2626', fontSize: 11 }}>(필수)</span>
              </label>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" checked={agreePrivacy} onChange={function(e) { setAgreePrivacy(e.target.checked); }} id="ck-privacy" style={{ flexShrink: 0 }} />
              <label htmlFor="ck-privacy" style={{ fontSize: 12, color: '#475569', cursor: 'pointer' }}>
                <a href="/privacy" target="_blank" style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 600 }}>개인정보처리방침</a>에 동의합니다 <span style={{ color: '#dc2626', fontSize: 11 }}>(필수)</span>
              </label>
            </div>
          </div>

          <button onClick={handleSubmit} disabled={loading || submitted} style={{ width: '100%', height: 48, backgroundColor: submitted ? '#16a34a' : '#0f172a', color: 'white', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: (loading || submitted) ? 'default' : 'pointer', fontFamily: "'Pretendard',sans-serif", boxShadow: '0 4px 12px rgba(15,23,42,0.2)', opacity: (loading || submitted) ? 0.85 : 1, marginTop: 4 }}
            onMouseEnter={function(e) { if (!loading && !submitted) { e.target.style.backgroundColor = '#2563eb'; e.target.style.boxShadow = '0 4px 16px rgba(37,99,235,0.3)'; } }}
            onMouseLeave={function(e) { if (!submitted) { e.target.style.backgroundColor = '#0f172a'; e.target.style.boxShadow = '0 4px 12px rgba(15,23,42,0.2)'; } }}
          >{submitted ? '✅ 신청 완료' : (loading ? '가입 처리 중...' : '무료 체험 시작')}</button>

          <div style={{ background: '#f0f9ff', borderRadius: 10, padding: '10px 14px', marginTop: 16, fontSize: 12, color: '#0369a1', lineHeight: 1.6 }}>
            <strong>승인 후 체험판 90일:</strong> OCR 스캔 100건/월, 서류 자동생성, 차량 관리, 인보이스 발행
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <span style={{ color: '#94a3b8', fontSize: 14 }}>이미 계정이 있으신가요? </span>
          <a href="/login" style={{ color: '#2563eb', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>로그인 →</a>
        </div>
        <div style={{ textAlign: 'center', marginTop: 32 }}><p style={{ color: '#cbd5e1', fontSize: 12 }}>© 2026 AUTODEX. All rights reserved.</p></div>
      </div>
    </div>
  );
}

export default Register;
